import { render } from "./AssetType1.vue?vue&type=template&id=613669bf"
import script from "./AssetType1.vue?vue&type=script&lang=js"
export * from "./AssetType1.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\monarch-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__